import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Contexts
import { CartProvider } from "@/context/CartContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import { SiteProvider } from "@/context/SiteContext";

// Layout Components
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { CartDrawer } from "@/components/cart/CartDrawer";
import { WhatsAppButton } from "@/components/common/WhatsAppButton";

// Pages
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CheckoutPage from "@/pages/CheckoutPage";
import FavoritesPage from "@/pages/FavoritesPage";
import { AboutPage, ReturnsPage, PrivacyPage, TermsPage, ContactPage } from "@/pages/StaticPages";

// Layout wrapper
const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col">
    <Header />
    <main className="flex-1">
      {children}
    </main>
    <Footer />
    <CartDrawer />
    <WhatsAppButton />
    <Toaster position="top-center" />
  </div>
);

function App() {
  return (
    <SiteProvider>
      <CartProvider>
        <FavoritesProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/loja" element={<ShopPage />} />
                <Route path="/produto/:id" element={<ProductPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/favoritos" element={<FavoritesPage />} />
                <Route path="/sobre-nos" element={<AboutPage />} />
                <Route path="/trocas-devolucoes" element={<ReturnsPage />} />
                <Route path="/privacidade" element={<PrivacyPage />} />
                <Route path="/termos" element={<TermsPage />} />
                <Route path="/contactos" element={<ContactPage />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </FavoritesProvider>
      </CartProvider>
    </SiteProvider>
  );
}

export default App;
